@if (loginState.loggedIn) {
  <div class="holder">
    <div class="history-input">
      <div class="action-container">
        <mat-select [(value)]="selectedCertificate">
          @for (certificate of holderService.holder.certificates; track certificate) {
            <mat-option [value]="certificate">{{certificate}}</mat-option>
          }
        </mat-select>
      </div>
      <!--<ng-select *ngIf="holderService.holder.certificates!==undefined"
      [items]="holderService.holder.certificates"
      bindLabel="label"
      bindValue="id"
      placeholder="{{strings.artesStrings['SEARCH']}}"
      name="certificate"
      id="select-certificate"
      (change)="setSelectedCertificate(selectedCertificateId)"
      [(ngModel)]="selectedCertificateId">
      <ng-template ng-option-tmp let-item="item" let-index="index">
        <span class="left">{{item.label}}</span>
      </ng-template>
    </ng-select>-->
  </div>
  @if (selectedCertificate !== undefined) {
    <div>
      <table id="substattable" class="maintable">
        <tr>
          <th (click)="sortTable('date')">{{strings.artesStrings['DATE']}}</th>
          <th (click)="sortTable('action')">{{strings.artesStrings['ACTION']}}</th>
          <th (click)="sortTable('userName')">{{strings.artesStrings['USER']}}</th>
          <th (click)="sortTable('comment')">{{strings.artesStrings['COMMENT']}}</th>
          <th></th>
        </tr>
        @for (action of selectedCertificate.actions; track action) {
          <tbody>
            <tr>
              <td>{{dateFormatter.dateToStr(action.date, 'ddmmyyyyhhmm')}}</td>
              <td>{{strings.artesStrings[action.action_type.action]}}</td>
              <td>{{action.user.first_name}} {{action.user.last_name}}</td>
              @if (action.data === null) {
                <td>
                  @if (action.action_type?.action === 'ISSUED') {
                    <span>
                      {{strings.artesStrings['ISSUED']}}
                    </span>
                  }
                  @if (action.action_type?.action !== 'ISSUED') {
                    <span>
                      @for (line of split(action.comment, '\\n'); track line) {
                        <div>
                          @for (entry of split(line, ';'); track entry; let i = $index) {
                            <span>
                              @if (strings.artesStrings[entry]) {
                                <span>@if (i==0) {
                                  <span>{{strings.artesStrings[entry] | titlecase}}</span>
                                  }@if (i>0) {
                                  <span>{{strings.artesStrings[entry] | lowercase}}</span>
                                }</span>
                              }
                              @if (!strings.artesStrings[entry]) {
                                <span>{{entry}}</span>
                              }
                            </span>
                          }
                        </div>
                      }
                    </span>
                  }
                </td>
              }
              @if (action.data !== null) {
                <td>
                  @for (change of parseChanges(action.data); track change) {
                    <div>
                      <span>{{strings.artesStrings[change.action]}} {{strings.artesStrings[change.constant] | lowercase}}
                        @if (change.object !== undefined) {
                          <span>
                            @if (change.constant === 'CERTIFICATE_LANGUAGE') {
                              <span>{{strings.artesStrings[change.object['iso2_code']?.toString().toUpperCase()]}}</span>
                            }
                            @if (change.constant === 'LANGUAGE') {
                              <span>{{strings.artesStrings[change.object['iso2_code']?.toString().toUpperCase()]}}</span>
                            }
                            @if (change.constant === 'CATEGORY') {
                              <span>{{change.object['category']}}</span>
                            }
                            @if (change.constant === 'STATION') {
                              <span>{{change.object['code']}} {{change.object['station']}}</span>
                            }
                            @if (change.constant === 'STRETCH') {
                              <span>{{change.object['code']}} {{change.object['stretch']}}</span>
                            }
                            @if (change.constant === 'ENGINE') {
                              <span>{{change.object['engine']}}</span>
                            }
                            @if (change.constant === 'CERTIFICATE_STATUS') {
                              <span>{{strings.artesStrings[change.object['status']]}}</span>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  }
                </td>
              }
              <td class="btnholder"><button (click)="streamCertificate(action)">{{strings.artesStrings['CERTIFICATE']}}</button></td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  }
</div>
}
